const INIT_STATE = {
  employees: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },
  users: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },
  user: {
    data: {},
    isLoading: false,
    isSuccess: false,
  },
  auth: {
    data: {},
    isLoading: false,
    isSuccess: false,
  },
  lecturers: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },

  users: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },
  students: {
    data: [],
    isLoading: false,
    isSuccess: false,
    error: '',
  },
  timeFrames: {
    data: [],
    isLoading: false,
    isSuccess: false,
    error: '',
  },
  courses: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },
  courseTypes: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },
  levels: {
    data: [],
    isLoading: false,
  },
  courseTypes: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },
  classes: {
    data: [],
    isLoading: false,
    isSuccess: false,
    isTeaching: false,
  },
  columnTranscripts: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },
  testTypes: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },
  exams: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },
  bills: {
    data: [],
    isLoading: false,
    isSuccess: false,
    error: '',
  },
  parameters: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },
};

export default INIT_STATE;
